import moment from "moment";

export const getCurrentTimestamp = moment().format("MMM D, h:mm A");
